var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState, useEffect } from 'react';
import { useCurrentAccount } from '@mysten/dapp-kit';
import { useNetworkString } from '../context/NetworkContext';
import { fetchUserPositionCapId } from '../utils/positionUtils';
/**
 * Hook to manage user's position cap ID
 * Automatically fetches position cap ID when wallet address or network changes
 */
export const usePositionCapId = () => {
    const [positionCapId, setPositionCapId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const currentAccount = useCurrentAccount();
    const network = useNetworkString();
    useEffect(() => {
        const fetchPositionCapId = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!(currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.address)) {
                setPositionCapId(null);
                setLoading(false);
                setError(null);
                return;
            }
            setLoading(true);
            setError(null);
            try {
                const id = yield fetchUserPositionCapId(network, currentAccount.address);
                setPositionCapId(id);
                console.log('📍 Position Cap ID fetched:', id || 'No position found');
            }
            catch (err) {
                const errorMessage = err instanceof Error ? err.message : 'Failed to fetch position cap ID';
                setError(errorMessage);
                console.error('❌ Error fetching position cap ID:', err);
            }
            finally {
                setLoading(false);
            }
        });
        fetchPositionCapId();
    }, [currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.address, network]);
    return {
        positionCapId,
        loading,
        error,
    };
};
